import { replaceIndex, REGEX } from '../table.js';

// Requires pubsub.js
export default function (...args)
{
	return {

		// If source is indexed, index will be replaced by the index of the current selector.
		// Source can be a single string or an array of strings pointing to multiple sources
		_source: args[0],

		captureEvents(_this = this)
		{
			this.hook();		// Must come after register()
			this.safeProtoCall(_this);
		},

		hook()
		{
			let names = Array.isArray(this._source) ? this._source : [this._source];
			names.forEach(name =>
			{
				let id = this.makeId(name)
				let field = this.locate(id);
				if (!field)
					throw Error(`Not found: ${id}`);
				field.subscribe(['change'], this.actions.bind(this), false);		// false: trigger always
			});
		},

		makeId(name)
		{
			let parts = this.getIdParts();
			let form = parts[1];								// 'form.'
			let index = parts[3];								// '-0'
			if (name.match(REGEX))
				name = replaceIndex(name, index.substr(1));		// 'name-0'
			return form + name;									// 'form.name-0'
		},

		getIdParts()
		{
			return this.getId().match(/([^.]+\.)([^-]+)(-\d+)?/);
		},

		async preventMultiCalls(object, primary_callback, secondary_callback, ...args)
		{
			let is_datalist_indexed = REGEX.test(document.querySelector(this.selector).getAttribute('list'));
			let is_action_ongoing = Boolean(object._this);
			if (!is_datalist_indexed && is_action_ongoing)
			{
				object._this.subscribe(['done'], secondary_callback);
			}
			else
			{
				object._this = this;
				await primary_callback(...args);
				if (!is_datalist_indexed)
					object._this.publish('done', ...args);
				object._this = null;
			}
		},

		actions(/* ev, publisher, value */)
		{
			// Tipos compostos (ex.: obs_load_options) sobrescrevem actions.
		}

	};
}

